const zIndex = {
  header: 1000,
  top: 9000,
  dropdown: 7000,
};

export type SystemZIndexMap = typeof zIndex;
export type SystemZIndex = keyof SystemZIndexMap;
export default zIndex;
